import React from 'react';

/** Neutral monogram tile standing in for a provider logo */
export const ProviderMark: React.FC<{ name: string; muted?: boolean; size?: 'sm' | 'md' }> = ({
  name,
  muted = false,
  size = 'md',
}) => (
  <span
    aria-hidden="true"
    className={`inline-flex flex-shrink-0 items-center justify-center rounded-full font-medium ${
      size === 'sm' ? 'h-5 w-5 text-[10px]' : 'h-8 w-8 text-[12px]'
    } ${muted ? 'bg-neutral-100 text-neutral-400' : 'bg-white text-ink ring-1 ring-inset ring-neutral-200'}`}
  >
    {name.charAt(0)}
  </span>
);
